import * as React from "react";
import * as ReactDOM from "react-dom";
import {connect} from "react-redux";

interface TimerStartProps
{

}

import './TimerStart.scss';

class TimerStart extends React.Component<TimerStartProps, null>
{
    constructor(public props: TimerStartProps)
    {
        super(props);
    }


    /**
     * render the component
     * @returns {JSX.Element}
     */
    render() : JSX.Element
    {
        return <span>

            <h3>timer is starting!</h3>



        </span>;
    }
}



/**
 * map the state to props
 * @param state
 */
const mapStateToProps = state =>
{
    return {

    }
};


/**
 * map dispatch functions to the component props
 * @param dispatch
 * @returns {{onModeSelect: ((mode: string) => any); onCountrySelect: ((country: string) => any)}}
 */
const mapDispatchToProps = dispatch =>
{
    return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(TimerStart);


// WEBPACK FOOTER //
// ./src/ts/app/screens/game/modals/timer-start/TimerStart.tsx